/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractFinderGridDefinition, rendererIconByName, truthyCellRenderer } from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { ColDef } from 'ag-grid-community';
import { getJobFinderId } from '../../resources/job-finder.model';

@Injectable()
export class JobFinderGridDefinition extends AbstractFinderGridDefinition {
  getId = getJobFinderId;

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      { field: 'jobNumber', comparator: () => 0, headerName: this.translationService.get('lbl_job'), width: 130 },
      { field: 'contactName', headerName: this.translationService.get('lbl_contact_customer') },
      { field: 'siteAddress', headerName: this.translationService.get('lbl_site_address') },
      {
        field: 'isFinalized',
        headerName: this.translationService.get('lbl_finalized'),
        width: 100,
        cellRenderer: truthyCellRenderer(rendererIconByName('done')),
      },
      {
        field: 'isDpp',
        headerName: this.translationService.get('lbl_dpp'),
        width: 70,
        cellRenderer: truthyCellRenderer(rendererIconByName('done')),
      },
    ];
  }

}
